<app-common-map
  [data]="mapData"
  [mapCenter]="mapCenter"
  [mapHeight]="'100%'"
  [showDropdown]="false"
  [canExpandMap]="false"
  [disableClustering]="false"
  [isLoading]="isLoading"
  [showMapLayerToggle]="true"
  [markerFactory]="markerFactory"
  [mapInfoWindowBuilder]="mapInfoWindowBuilder"
  [clusterRenderer]="clusterRenderer"
  (markerClicked)="onMarkerClicked($event)">
</app-common-map>